import { isEmpty, isEqual, xorWith } from 'lodash';

export * from './config';
export const isArrayEqual = (x: any, y: any): boolean => isEmpty(xorWith(x, y, isEqual));
export const splitLast = (str: string, separator: string): Array<string> => {
  const results = str.split(separator);
  if (results.length > 2) {
    const [last] = results.splice(-1);
    const prefix = results.join(separator);
    return [prefix, last];
  }
  return results;
};
export const pad = (str: string): string => `0${str}`.slice(-2);
export const padDate = (str: string): string => {
  const date = new Date(str);
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const year = date.getFullYear();
  return `${pad(month.toString())}/${pad(day.toString())}/${year}`;
};
